<!-- Milestone - Display Rewards -->
<div *ngIf="badges != undefined">
	<div *ngIf="badges.length > 0">
		<img src="../Admin/ImageResizer.aspx?imgid={{badges[0]}}&w=26&h=26" class="img-fluid" />
		<div *ngIf="gs.selectedGame && gs.selectedGame[0] && gs.selectedGame[0].underlyingRule.GameType == 5 && badges.length > 1">
			<div class="row m-0" style="min-width: 35px; max-width: 60px;">
				<div *ngFor="let badgeID of badges; let index = index" class="col p-0" [hidden]="index<=0">
					<img [src]="'../Admin/ImageResizer.aspx?imgid=' + badgeID + '&w=26&h=26'" />
				</div>
			</div>
		</div>
	</div>
	
	<div *ngIf="isNumeric(badges)">{{badges}}</div>

	<div *ngIf="badges.length <=0 && !isNumeric(badges)">
		<span>---</span>
	</div> 
</div>

<div *ngif="badges === undefined">
	<span>---</span>
</div>